import { deleteFileCategory } from "actions/Utilities/FileCategory";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { fileCategoryReFetching } from "../atoms/atoms";

export default function useDeleteFileCategory() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    fileCategoryReFetching
  );

  const { mutate } = useMutation((ids: number[]) => deleteFileCategory(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling File Category failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "File Category Disabled Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `File Category Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling File Category failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "File Category not found":
            toast.fire(
              "Disabling File Category failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire("Disabling File Category failed", res, "error");
        }
      }
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling File Category failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}
